import { useState } from "react";
import userProfile1 from "../../../assets/images/userProfile1.png";
import "../css/games.css";

export default function DisplayUsers({ users, btnTxt, btnFunc, accountType }) {
  const [hoveredUser, setHoveredUser] = useState();
  const displayUsers = users.map((user, i) => {
    const { username, numberOfWins, avatar } = user;
    const onMouseOver = (e) => setHoveredUser(username);
    const onMouseLeave = () => setHoveredUser("");

    const onClickUser = () => (btnFunc ? btnFunc(user) : null);

    const isHovered = hoveredUser === username ? true : false;

    return (
      <div key={i} className="flex items-center justify-between mb-3">
        <div className="w-full flex items-center relative">
          <div
            className={`border-2  rounded-full flex flex-col items-center justify-center p-1 ${
              accountType === "celebrity"
                ? "border-green-500"
                : "border-yellow-400"
            }`}
          >
            <img
              src={avatar ?? userProfile1}
              alt="Avatar"
              className="rounded-full w-10 h-10 object-cover"
            />
          </div>

          <div className="ml-3 text-white">
            <p className="m-0 p-0 mb-2 text-white text-sm font-poppins font-semibold">
              {username}
            </p>
            <p className={`m-0 p-0 text-sm font-poppins  font-light ${
              accountType === "celebrity"
                ? "text-green-500"
                : "text-yellow-400"
            }`}>
              {numberOfWins} {numberOfWins === 1 ? "win" : "wins"}
            </p>
          </div>

          {/* {isOnline && (
            <div className="absolute left-[110%] top-1/2 transform -translate-y-1/2 w-3 h-3 bg-green-500 rounded-full ring-2 ring-black"></div>
          )} */}
        </div>

        <button
          onClick={onClickUser}
          onMouseOver={onMouseOver}
          onMouseLeave={onMouseLeave}
          className={`w-1/4 rounded-full bg-transparent flex items-center justify-center p-1 transition-colors duration-200
  hover:bg-white border ${
    accountType === "celebrity" ? "border-green-500" : "border-white"
  }`}
        >
          <p
            className={`p-0 m-0 text-capitalize text-sm font-medium font-poppins mx-1 ${
              isHovered ? "text-black" : "text-white"
            } `}
          >
            {btnTxt || "Continue"}
          </p>
        </button>
      </div>
    );
  });

  return <div>{displayUsers}</div>;
}
